import { ElNotification, type NotificationOptions } from 'element-plus'

const NOTIFICATION_Z_INDEX = 10002

type OptionsType = Partial<NotificationOptions> | string
const handleOptions = (options: OptionsType): Partial<NotificationOptions> => {
  const topOffset = 72

  if (typeof options === 'string') {
    return {
      offset: topOffset,
      zIndex: NOTIFICATION_Z_INDEX,
      message: options,
    }
  } else {
    return {
      ...((options.position === 'top-right' ||
        options.position === 'top-left' ||
        !options.position) && { offset: topOffset }),
      zIndex: NOTIFICATION_Z_INDEX,
      ...options,
    }
  }
}

export const notification = (options: OptionsType) => ElNotification(handleOptions(options))
notification.success = (options: OptionsType) =>
  notification({ ...handleOptions(options), type: 'success' })
notification.error = (options: OptionsType) =>
  notification({ ...handleOptions(options), type: 'error' })
notification.info = (options: OptionsType) =>
  notification({ ...handleOptions(options), type: 'info' })
notification.warning = (options: OptionsType) =>
  notification({ ...handleOptions(options), type: 'warning' })
